import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  flex: {
    flex: 1
  },
  image: {
    maxWidth: 100
  }
}))
